// Personal Toolkit — a private collection of what works for the user.
// Key: un_toolkit_v1 — [{ id, type, label, detail?, refId?, createdAt }]
// Types: exercise (saved reset), strategy, reason, contact, note

import { track } from "@/lib/analytics";

const KEY = "un_toolkit_v1";
export const FREE_TOOLKIT_LIMIT = 8;

export const TOOLKIT_TYPES = [
  { id: "exercise", label: "Reset exercise", hint: "A technique that works for you" },
  { id: "strategy", label: "Coping strategy", hint: "Something that helps you through" },
  { id: "reason", label: "Reason to pause", hint: "Why waiting is worth it" },
  { id: "contact", label: "Someone to reach", hint: "A person you can contact" },
  { id: "note", label: "Private note", hint: "Anything worth keeping close" },
];

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};
const write = (v) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch (e) {
    console.warn("[toolkit] write:", e?.message || e);
  }
};

const uid = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export const getToolkitItems = () => read();

export const isExerciseSaved = (refId) =>
  read().some((i) => i.type === "exercise" && i.refId === refId);

// Returns { ok, item?, reason? } — reason 'limit' when free cap is hit.
export const addToolkitItem = ({ type, label, detail, refId }, { premium } = {}) => {
  const items = read();
  if (!premium && items.length >= FREE_TOOLKIT_LIMIT) {
    return { ok: false, reason: "limit" };
  }
  if (refId && items.some((i) => i.refId === refId)) {
    return { ok: false, reason: "duplicate" };
  }
  const item = {
    id: uid(),
    type,
    label: (label || "").trim(),
    detail: detail ? detail.trim() : null,
    refId: refId || null,
    createdAt: new Date().toISOString(),
  };
  items.unshift(item);
  write(items);
  track("tool_saved", { type });
  return { ok: true, item };
};

export const deleteToolkitItem = (id) => {
  write(read().filter((i) => i.id !== id));
};

export const TOOLKIT_KEY = KEY;
